/**
 * Reefer Start Measurement Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.reeferStartMeasurementFormatter = function(value, row) {
    let html = '';
    if (parseInt(row.can_start, 10) === 1) {
        html += '<button class="button-reefer-start-measurement btn btn-sm btn-outline-success me-3" data-id="'+row.reefer_id+'" data-container-number="'+row.container_number+'">';
        html += __('Start measurement');
        html += '</button>';
    } else {
        html += '<button class="btn btn-sm btn-outline-secondary disabled me-3">';
        html += __('Start measurement');
        html += '</button>';
    }
    return html;
};
